import React from 'react';
import { useLocation } from 'react-router-dom';
import RouteErrorBoundary from '@/shared/components/RouteErrorBoundary';

/**
 * GH#2404 — App.tsx monta TODAS las rutas en la misma posición del árbol, así que al navegar
 * React reutiliza la misma instancia de RouteErrorBoundary. Sin `resetKey`, el error de una
 * pantalla se quedaba puesto en todas las demás del menú hasta pulsar «Reintentar» o recargar.
 *
 * Se reinicia por UBICACIÓN y no con `key={path}`: hay rutas con parámetros
 * (`/agencia/crm/leads/:id`) donde el patrón no cambia entre un detalle y otro, y una `key`
 * por ubicación volvería a montar las páginas SANAS en cada cambio de parámetro.
 */
const BoundaryDeRuta: React.FC<{ moduleName: string; routePath: string; children: React.ReactNode }> = ({
  moduleName,
  routePath,
  children,
}) => {
  const { pathname } = useLocation();
  return (
    <RouteErrorBoundary moduleName={moduleName} routePath={routePath} resetKey={pathname}>
      {children}
    </RouteErrorBoundary>
  );
};

export default BoundaryDeRuta;
